import { w3cwebsocket as W3CWebSocket } from "websocket";
import {v4}                             from "uuid";
import {notification}                   from "antd";
import locale                           from "../localization/locale";

const events = {"message" : {}};

const init = ({token, sid}) => {
    if(!token)
        return;

    const url = process.env.REACT_APP_SOCKET_URL

    let client = new W3CWebSocket(`${url}?token=${token}&sid=${sid}`, 'echo-protocol');

    client.onerror = (error) => {
        console.log('Connect Error');
    };

    client.onopen = () =>  {
        console.log('WebSocket Client Connected');
    };

    client.onclose = () => {
        console.log('Connection Closed. Try to reconnect');
        setTimeout(() => init({token, sid}), 5000)
    };
    client.onmessage = (message) => {
        if (message.type === 'message') {
            let data = JSON.parse(message.data);

            console.log(data)
            Object.values(events[data.type] || {}).forEach(fn => fn(data));
            Object.values(events["message"] || {}).forEach(fn => fn(data));

            const notificationTitle = locale.get(`socket.${data.type}.title`)
            notificationTitle && notification.info({message: notificationTitle});
        }
    };
};

const on = (type, fn) => {
    let event_id = v4();
    events[type] = events[type] || {};
    events[type][event_id] = fn;
    return {
        off : () => delete events[type][event_id]
    }
};

const methods = {
    init,
    on
}

export default methods

